import React from "react";
import { Box, Paper, useTheme } from "@mui/material";
import { useChromeTabFlush } from "./chromeTabFlushContext";

export type FormSurfaceProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  "aria-label"?: string;
  fill?: boolean;
};

export function FormSurface({ header, footer, children, "aria-label": ariaLabel, fill = true }: FormSurfaceProps) {
  const theme = useTheme();
  const flushTop = useChromeTabFlush();

  return (
    <Paper
      component="section"
      role="region"
      aria-label={ariaLabel}
      elevation={0}
      data-flush-top={flushTop ? "true" : undefined}
      sx={{
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: theme.palette.background.paper,
        ...(flushTop && {
          borderTop: "none",
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
        }),
        ...(fill && {
          height: "100%",
          minHeight: 0,
          flex: 1,
        }),
      }}
    >
      {header != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          {header}
        </Box>
      ) : null}

      <Box
        data-testid="form-surface-body"
        sx={{
          flex: 1,
          minHeight: 0,
          // fill=true: the child (list / form+tabular) is the scroll host.
          // overflow:auto here stole the wheel from TabularGrid and grew the form.
          overflow: fill ? "hidden" : "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>

      {footer != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {footer}
        </Box>
      ) : null}
    </Paper>
  );
}